import { ILopUpdateCTDTRequest } from "../../model/request/category/ILopUpdateCTDTRequest";
import { apiClient } from "../apiClient";
export const lopApi = {
  SelectByNamHoc: (nam_hoc: string) => apiClient.get(`nam-hoc/${nam_hoc}/lop`),
  UpdateCTDT: (payload: ILopUpdateCTDTRequest) => apiClient.put(`lop/ctdt`, payload),
  SelectByUser: () => apiClient.get(`lop/user`),
  SelectAll: () => apiClient.get(`lop`),
};
